/**
 * Created by JackCui on 2020/12/3
 */

const process = {
  prcessList: {
    url: '/file/systemprogress/listNotice',
    type: 'post'
  },
  // 任务进程记录删除
  processDlelte: {
    url: '/file/systemprogress/delete',
    type: 'post'
  },
  // 下载任务进程
  downloadData: {
    url: '/file/systemprogress/downloadData',
    type: 'get'
  },
  getToken: {
    url: '/userauth/assist/getAccessoryToken',
    type: 'get'
  }
}

export default process
